'use client';

import type { ReactNode } from 'react';
import { Field } from '../field';

export type FieldWrapperProps = {
  label: string;
  children: ReactNode;
  helperText?: string;
  isRequired?: boolean;
  error?: string;
};

export const FieldWrapper = ({
  label,
  children,
  helperText,
  isRequired,
  error,
}: FieldWrapperProps) => {
  const isValid = !error;

  return (
    <Field.Root invalid={!isValid}>
      <Field.Label fontSize="xs">
        {isRequired ? (
          <>
            <Field.Mandatory />{' '}
          </>
        ) : null}
        {label}
      </Field.Label>
      {children}
      {helperText && isValid && (
        <Field.HelperText fontSize="xs" color="fg.muted">
          {helperText}
        </Field.HelperText>
      )}
      <Field.ErrorText fontSize="xs" color="fg.neutral.error">
        {error}
      </Field.ErrorText>
    </Field.Root>
  );
};
